import { createAsyncThunk } from "@reduxjs/toolkit";
import config from "../../config";
import axiosClient from "../../common/api/request";

export const getTeamMembers = createAsyncThunk(
  "TeamMembers",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL}/accounts/`,
        { params },
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);
export const patchTeamMember = createAsyncThunk(
  "patchTeamMember",
  async (params, { rejectWithValue }) => {
    try {
      const { id, ...payloadWithoutId } = params;
      const data = await axiosClient.patch(
        `${config.API_URL}/accounts/${params?.id}/`,
        payloadWithoutId,
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);
export const postTeamMember = createAsyncThunk(
  "postTeamMember",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.post(
        `${config.API_URL}/accounts/`,
        { ...params },
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);
export const deleteTeamMember = createAsyncThunk(
  "deleteTeamMember",
  async (params, { rejectWithValue }) => {
    try {
      // 204 No Content — empty body, nothing to read back.
      await axiosClient.delete(
        `${config.API_URL}/accounts/${params?.id}/`,
        params,
        config
      );
      return { id: params?.id };
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);
